import service from "../../../lib";
import { AxiosResponse } from "axios";

export type ConsentLogsResponse<T = any> = AxiosResponse<T>;

export type CreateConsentLogsParams = {
  consent_date: string;
  consent: boolean;
};

const consentApi = {
  getConsentLogs: <T = any>(): Promise<ConsentLogsResponse<T>> => {
    return service.get<T>(`consent-logs`);
  },
  
  createConsentLogs: <T = any>(params: CreateConsentLogsParams): Promise<ConsentLogsResponse<T>> => {
    return service.post<T>(`consent-logs`, params);
  },
};

export default consentApi;